// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"P4-z","dimensionLabel":"Q4-z","styleChooserControlWrapper":"R4-z","styleChooserControl":"S4-z","disabled":"T4-z","giftCard":"U4-z","styleChooserText":"V4-z"};